/**
 * MMO Combat Log (Legacy)
 * This class is kept for type compatibility but is no longer used visually.
 * All logging is now handled by the LOG tab in EnhancedChatPanel.
 */

import Phaser from 'phaser';

export class MMOCombatLog extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    this.setVisible(false);
    scene.add.existing(this);
  }

  public clearLog(): void {
    // No-op — kept for API compat
  }

  public log(_text: string, _category?: string, _color?: string): void {
    // No-op — logging handled by EnhancedChatPanel LOG tab
  }
}
